'use client';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { getSummaryName } from '@/components/memul/detail/sub/summaryInfo/summaryName';
import { BUSINESS_DIV_TYPE, BusinessDivKey } from '@/const/buildingType';
import memulQueries from '@/service/memul/memulQueries';
import useMobileStore from '@/store/mobileStore';
import { handleSendGAEvent } from '@/utils/google';
import { numberToNormalPrice } from '@/utils/js/number';
import { sendTextMessage } from '@/utils/js/sms';

export default function RealtorCall({ articleCd }: { articleCd: string }) {
  const { currentDevice, isWebView } = useMobileStore();
  const handlePriceText = (data: any) => {
    if (!data) return;
    const { businessDiv, tradePrice, depositPrice } = data;
    if (businessDiv === 'M' || businessDiv === 'T') {
      return `${numberToNormalPrice({ value: depositPrice })} / ${numberToNormalPrice({ value: tradePrice })}`;
    } else {
      return `${numberToNormalPrice({ value: tradePrice })}`;
    }
  };

  const { data: memulData } = useQuery({
    ...memulQueries.memulDetail(articleCd as string),
    select: (data) => data.data,
  });

  const { data: realtorData } = useQuery({
    ...memulQueries.realtorInfo(articleCd as string),
    select: (data) => data.data,
  });

  const handleSmsText = () => {
    return `[이실장] ${getSummaryName(memulData, 'villaDanji')} ${BUSINESS_DIV_TYPE[realtorData?.businessDiv as BusinessDivKey]} ${handlePriceText(realtorData)} 매물 문의드립니다.\n${window.location.href}`;
  };

  useEffect(() => {
    if (isWebView) {
      handleSendGAEvent('page_view', {
        event_category: 'memul',
        page_title: 'memul_memul_detail_inquiry',
        memul_id: articleCd,
        realtor_id: realtorData?.agencySeq,
      });
    } else {
      handleSendGAEvent('page_view', {
        event_category: 'share',
        page_title: 'share_memul_inquiry',
        memul_id: articleCd,
        realtor_id: realtorData?.agencySeq,
      });
    }
  }, []);

  const handleSendCallGaEvent = () => {
    if (isWebView) {
      handleSendGAEvent('memul_memul_detail_inquiry_call_btn', {
        event_category: 'memul',
        memul_id: articleCd,
        realtor_id: realtorData?.agencySeq,
      });
    } else {
      handleSendGAEvent('share_memul_inquiry_call_btn', {
        event_category: 'share',
        memul_id: articleCd,
        realtor_id: realtorData?.agencySeq,
      });
    }
  };

  const handleSendSmsGaEvent = () => {
    if (isWebView) {
      handleSendGAEvent('share_memul_inquiry_sms_btn', {
        event_category: 'share',
        memul_id: articleCd,
        realtor_id: realtorData?.agencySeq,
      });
    } else {
      handleSendGAEvent('memul_memul_detail_inquiry_sms_btn', {
        event_category: 'memul',
        memul_id: articleCd,
        realtor_id: realtorData?.agencySeq,
      });
    }
  };

  return (
    <>
      <div className="realtor_call">
        <div className="tag_div">
          {realtorData?.agencyInfos?.sSafeRealestateAgencyYN === 'Y' ? (
            <span className="tag_care"></span>
          ) : realtorData?.agencyInfos?.sSafeCareJoinYN === 'Y' ? (
            <span className="tag_care_join"></span>
          ) : (
            ''
          )}
        </div>
        <div className="realtor_name">{realtorData?.rname}</div>
        <div className="property_info">
          <div className="tag_div">
            <span className="tag">매물번호 {articleCd}</span>
          </div>
          <div className="price_info">
            <p
              className={`type  
                ${realtorData?.businessDiv === 'S' ? 'text_blue' : ''}  
                ${realtorData?.businessDiv === 'Y' ? 'text_green' : ''}     
                ${realtorData?.businessDiv === 'M' ? 'text_pink' : ''}     
                ${realtorData?.businessDiv === 'T' ? 'text_mint' : ''}`}
            >
              {BUSINESS_DIV_TYPE[realtorData?.businessDiv as BusinessDivKey]}
            </p>
            <p className="price">{handlePriceText(realtorData)}</p>
          </div>
          <address className="address">{getSummaryName(memulData, 'villaDanji')}</address>
        </div>
        <div className="box_tip">
          <i className="icon_counselor"></i>
          <p>“이실장”을 보고 연락했다고 말해주시면 더욱 빠른 상담이 가능합니다.</p>
        </div>
      </div>

      <div className="bottom_btn">
        <div className="group_btn ratio">
          {realtorData?.phoneExps === 'A' || realtorData?.phoneExps === 'C' ? (
            <>
              <a
                href={`tel:` + realtorData?.cphone}
                className="btn_gray50"
                onClick={handleSendCallGaEvent}
              >
                <i className="icon_call_black"></i>
                전화
              </a>
              <a
                href={sendTextMessage(realtorData?.cphone, handleSmsText(), currentDevice!)}
                className="btn_primary"
                onClick={handleSendSmsGaEvent}
              >
                <i className="icon_text_msg"></i>
                문자
              </a>
            </>
          ) : (
            <a
              href={`tel:` + realtorData?.rphone}
              className="btn_primary"
              onClick={handleSendCallGaEvent}
            >
              <i className="icon_call_white"></i>
              전화
            </a>
          )}
        </div>
      </div>
    </>
  );
}
